<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_2_' + this.id]">
    <div class="img">
      <div class="bulle">
        <div class="cadre">
          <p>Bravo, tu es presque un·e expert·e en réparation de ballon-songe maintenant !</p>

          <p>D'ici quelques jours, je te propose même qu'on essaye d'apprendre ensemble à les piloter.</p>

          <p>
            Tu pourras rentrer le code <span class="italic">Stratiformis</span> quand la troisième immersion sera
            lancée.
          </p>

          <p>
            En attendant, il va falloir apprendre à construire ton propre ballon-songe. Nous t'avons préparé des
            explications. Envoie nous le résultat sur contact@exploreve.fr !
          </p>
        </div>
      </div>

      <div class="leon">
        <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="" />
      </div>
      <div class="support"></div>
    </div>

    <div>
      <NextButton class="button" url="/immersion03/1" text="Accéder à l'imersion 3" @click="resetTracker" />
    </div>

    <div class="cadre-video">
      <p>Apprend ici à constuire ton ballon</p>
      <video ref="vid" @ended="show_link" class="end-vid" controls crossorigin="anonymous">
        <source src="https://cdn.exploreve.fr/content/IM2/tuto_ballon.webm" type="video/webm" />
        <source src="https://cdn.exploreve.fr/content/IM2/tuto_ballon.mp4" type="video/mp4" />
        Vidéo non supportée.
      </video>
    </div>

    <div class="nuage n01"></div>
    <div class="nuage n02"></div>
    <div class="nuage n03"></div>
    <div class="nuage n04"></div>
    <div class="nuage n05"></div>
    <div class="nuage n06"></div>
    <div class="nuage n07"></div>
    <div class="nuage n08"></div>

    <div class="ballon_vert">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_vert.svg" alt="" />
    </div>

    <div class="ballon_rouge">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_rose.svg" alt="" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NextButton from "@/components/NextButton.vue";
import Tracker from "@/services/ProgressTracker";

export default {
  name: "IM_2_6",
  data: function () {
    return {
      id: 7
    };
  },
  components: {
    NextButton
  },
  methods: {
    resetTracker() {
      Tracker.resetTrackerImmersion();
    }
  }
};
</script>

<style scoped lang="scss">
.cadre-video {
  position: relative;
  left: 70%;
  top: 350px;
  width: 400px;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  padding-bottom: 20px;
  font-family: "faune";
  z-index: 10;
}

video.end-vid {
  position: relative;
  margin: 0px auto;
  z-index: 5;
  height: 150px;
}

.next {
  z-index: 10;
}

.button {
  position: absolute;
  bottom: 10%;
  left: 20%;
  z-index: 20;
}

.container {
  text-align: left;
}

.title {
  margin-top: 100px;
}

p {
  font-size: 24px;
  .italic {
    font-style: italic;
    color: $dark;
  }
}

.ballon_vert {
  position: absolute;
  height: 30px;
  top: 65%;
  left: 5%;
  img {
    height: 20vh;
  }
  z-index: 5;
}

.ballon_rouge {
  position: absolute;
  height: 30px;
  top: 15%;
  left: 85%;
  img {
    height: 25vh;
  }
  z-index: 5;
}

.img {
  position: absolute;
  top: 10%;
  left: 15%;
  z-index: 10;
}

.bulle {
  position: absolute;
  top: 20px;
  left: 0px;
  z-index: 10;
}

.cadre {
  position: absolute;
  background-color: white;
  width: 540px;
  border-radius: 20px;
  text-align: left;
  padding: 20px;
  z-index: 10;
}

.cadre::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 15%;
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 60px solid white;
}

.leon {
  position: absolute;
  top: 10%;
  left: 570px;
  img {
    height: 80vh;
  }
  z-index: 5;
}

.support {
  position: absolute;
  background-color: $light;
  left: 530px;
  top: 70vh;
  height: 15vh;
  width: 38vh;
  -webkit-border-radius: 19vh / 8vh;
  -moz-border-radius: 19vh / 8vh;
  border-radius: 19vh / 8vh;
}

.nuage {
  position: absolute;
  background-color: $light;
  opacity: 0.7;
}

.n01 {
  top: 10%;
  left: 40%;
  width: 619px;
  height: 121px;
  border-radius: 60px;
  z-index: 0;
}

.n02 {
  top: 30%;
  left: 80%;
  width: 197px;
  height: 33px;
  border-radius: 15px;
  z-index: 0;
}

.n03 {
  top: 35%;
  left: -5%;
  width: 641px;
  height: 145px;
  border-radius: 72px;
  z-index: 0;
}

.n04 {
  top: 35%;
  right: 0px;
  width: 317px;
  height: 62px;
  border-radius: 31px 0px 0px 31px;
  z-index: 10;
}

.n05 {
  top: 45%;
  left: 10%;
  width: 641px;
  height: 145px;
  border-radius: 72px;
  z-index: 0;
}

.n06 {
  top: 50%;
  left: 60%;
  width: 426px;
  height: 74px;
  border-radius: 72px;
  z-index: 0;
}

.n07 {
  top: 70%;
  left: 30%;
  width: 317px;
  height: 62px;
  border-radius: 31px;
  z-index: 5;
}

.n08 {
  top: 80%;
  left: -20%;
  width: 617px;
  height: 121px;
  border-radius: 60px;
  z-index: 5;
}
</style>
